import { action } from 'typesafe-actions';
import { AnnouncementActionTypes } from 'types';

export const getAnnouncementsStart = (payload: any) =>
  action(AnnouncementActionTypes.GET_ANNOUNCEMENTS_START, payload);

export const getAnnouncementsSuccess = (payload: any) =>
  action(AnnouncementActionTypes.GET_ANNOUNCEMENTS_SUCCESS, payload);

export const getAnnouncementsFailure = (payload: string) =>
  action(AnnouncementActionTypes.GET_ANNOUNCEMENTS_FAILURE, payload);

export const getListAnnouncementsStart = (payload: any) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_START, payload);

export const getListAnnouncementsSuccess = (payload: any) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_SUCCESS, payload);

export const getListAnnouncementsFailure = (payload: string) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_FAILURE, payload);

export const removeAllAnnouncements = () =>
  action(AnnouncementActionTypes.REMOVE_ALL_ANNOUNCEMENT);

export const removeAnnouncement = (id: number) =>
  action(AnnouncementActionTypes.REMOVE_ANNOUNCEMENT, id);

export const hideAnnouncementStart = (id: number) =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_START, id);

export const hideAnnouncementSuccess = () =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_SUCCESS);

export const hideAnnouncementFailure = (payload: string) =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_FAILURE, payload);

export const unhideAnnouncementStart = (id: number) =>
  action(AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_START, id);

export const unhideAnnouncementSuccess = () =>
  action(AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_SUCCESS);

export const unhideAnnouncementFailure = (payload: string) =>
  action(AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_FAILURE, payload);

export const hideAnnouncementBulkStart = (payload: Array<number>) =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_START, payload);

export const hideAnnouncementBulkSuccess = () =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_SUCCESS);

export const hideAnnouncementBulkFailure = (payload: string) =>
  action(AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_FAILURE, payload);

export const deleteAnnouncementStart = (id: number) =>
  action(AnnouncementActionTypes.DELETE_ANNOUNCEMENT_START, id);

export const deleteAnnouncementSuccess = () =>
  action(AnnouncementActionTypes.DELETE_ANNOUNCEMENT_SUCCESS);

export const deleteAnnouncementFailure = (payload: string) =>
  action(AnnouncementActionTypes.DELETE_ANNOUNCEMENT_FAILURE, payload);

export const updateAnnouncementStart = (payload: any) =>
  action(AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_START, payload);

export const updateAnnouncementSuccess = () =>
  action(AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_SUCCESS);

export const updateAnnouncementFailure = (payload: string) =>
  action(AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_FAILURE, payload);

export const addAnnouncementStart = (payload: any) =>
  action(AnnouncementActionTypes.ADD_ANNOUNCEMENT_START, payload);

export const addAnnouncementSuccess = () =>
  action(AnnouncementActionTypes.ADD_ANNOUNCEMENT_SUCCESS);

export const addAnnouncementFailure = (payload: string) =>
  action(AnnouncementActionTypes.ADD_ANNOUNCEMENT_FAILURE, payload);
